module.exports = require('immediate')



//////////////////
// WEBPACK FOOTER
// ./~/memdown/immediate-browser.js
// module id = 711
// module chunks = 0